<sim-base-camera-layout
	[cameraLayoutOptionsContainer]="{
		optionType: 'Playback',
		options: {
			screens: screens,
			cameraViewMode: CameraViewMode.AllScreens,
			cameraLayoutType: scenarioRecordingScene?.cameraLayout,
			cameraLayoutOption: scenarioRecordingScene?.cameraLayoutOption,
		},
	}"
/>

<audio id="audio-container"></audio>
